export enum PaymentTypeEnum {
  Full = 'full',
  Enterprise = 'enterprise',
  Agency = 'agency'
}
